import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { DrawerModule, PipesModule } from '../../../../shared';
import { CountrySelectorComponent } from './country-selector.component';

@NgModule({
  declarations: [CountrySelectorComponent],
  imports: [
    CommonModule,
    DrawerModule,
    NzIconModule,
    I18nModule,
    PipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CmsFooterCountrySelectorComponent: {
          component: CountrySelectorComponent,
        },
      },
    }),
  ],
  exports: [CountrySelectorComponent],
})
export class CountrySelectorModule {}
